import { render, staticRenderFns } from "./message-field.vue?vue&type=template&id=3e4a8c25"
import script from "./message-field.vue?vue&type=script&lang=js"
export * from "./message-field.vue?vue&type=script&lang=js"
import style0 from "./message-field.vue?vue&type=style&index=0&id=3e4a8c25&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports